import { useAppStore } from "../stores/appStore";
import { postRealtimeMenu } from "../axios/realtimeSpeech";

/**
 * Finish active sessions of role-playing game and coaching
 * Called when user switches to another tab/device
 */
export const endActiveSessions = async (): Promise<void> => {
  const {
    sellingDialogue,
    liveSpeechMode,
    realtimeMenuOptions,
    lessonDialogue,
    asyncRoleplayOpen,
    setSellingDialogue,
    setLiveSpeechMode,
    setRealtimePersona,
    setRealtimeMaturityLevel,
    setRealtimeMenuOptions,
    setLessonDialogue,
    setLessonDialogueMetadata,
    setLessonTurnsAllowed,
    setLessonTurnsUsed,
    setAsyncRoleplayOpen,
    setAsyncRoleplaySessionId,
    setAsyncRoleplayRecordId,
    setRealtimeDetailsWindowText,
  } = useAppStore.getState();

  if (sellingDialogue || lessonDialogue || asyncRoleplayOpen) {
    window.dispatchEvent(new CustomEvent("forceCloseActiveSessions"));

    await new Promise((resolve) => setTimeout(resolve, 100));
  }

  if (sellingDialogue) {
    const wasCoachMode = liveSpeechMode === "coach_me";
    const recordId = realtimeMenuOptions?.record_id;

    if (wasCoachMode && recordId) {
      try {
        await postRealtimeMenu({
          record_id: recordId,
          realtime_mode: "coach_me",
          complete: true,
        });
      } catch (error) {
        console.error("Error completing coaching mode:", error);
      }
    }

    setSellingDialogue(false);
    setLiveSpeechMode(null);
    setRealtimePersona(null);
    setRealtimeMaturityLevel(null);
    setRealtimeMenuOptions({});
    setLessonTurnsUsed(0);
    setRealtimeDetailsWindowText(null);
  }

  if (lessonDialogue) {
    setLessonDialogue(false);
    setLessonDialogueMetadata(null);
    setLessonTurnsAllowed(null);
    setLessonTurnsUsed(0);
  }

  if (asyncRoleplayOpen) {
    // Pause only — do not finish the async session on device switch.
    setAsyncRoleplayOpen(false);
    setAsyncRoleplaySessionId(null);
    setAsyncRoleplayRecordId(null);
  }
};
